import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';

type DeleteTransactionModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading: boolean;
};

export const DeleteTransactionModal: React.FC<DeleteTransactionModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
}) => {
    const { t } = useTranslation('documents');

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="space-y-4">
                <h3 className="text-lg font-semibold">{t('confirmDeleteTitle')}</h3>
                <p className="text-sm text-zinc-600">{t('confirmDeleteTransactionMessage')}</p>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={onClose} disabled={isLoading}>
                        {t('cancelButton')}
                    </Button>
                    <Button onClick={onConfirm} disabled={isLoading} variant="destructive">
                        {isLoading ? t('deletingButton') : t('deleteButton')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
